module.exports = __webpack_public_path__ + "img/icon-nav7_blue.bf44ac89.svg";